var path = 'entity/entity-type-select.tpl.html';
var html = " <md-input-container> <label ng-if=showLabel>{{ 'entity.type' | translate }}</label> <md-select ng-required=tbRequired ng-disabled=disabled name=entityType ng-model=entityType class=tb-entity-type-select aria-label=\"{{ 'entity.type' | translate }}\"> <md-option ng-repeat=\"type in entityTypes\" ng-value=type> {{typeName(type) | translate}} </md-option> </md-select> <div ng-messages=theForm.entityType.$error> <div ng-message=required translate>entity.type-required</div> </div> </md-input-container> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/entity/entity-type-select.tpl.html
// module id = 1472
// module chunks = 1